
import React, { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface TerminalProps {
  className?: string;
  children: React.ReactNode;
  title?: string;
  showHeader?: boolean;
  ref?: React.RefObject<HTMLDivElement>;
}

export default function Terminal({ className, children, title = "terminal", showHeader = true, ref }: TerminalProps) {
  const terminalRef = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // Scroll to the bottom of the terminal
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [children]);

  if (!mounted) return null;

  return (
    <div ref={ref} className={cn("terminal-glass w-full overflow-hidden", className)}>
      {showHeader && (
        <div className="h-9 px-4 flex items-center justify-between border-b border-terminal-pink/10">
          <div className="flex items-center space-x-2">
            <div className="h-3 w-3 rounded-full bg-terminal-pink/80" />
            <div className="h-3 w-3 rounded-full bg-terminal-yellow/80" />
            <div className="h-3 w-3 rounded-full bg-terminal-green/80" />
          </div>
          <div className="text-xs text-muted-foreground font-medium">{title}</div>
          <div className="w-16" />
        </div>
      )}
      <div 
        ref={terminalRef} 
        className="p-4 font-mono text-sm overflow-y-auto max-h-[500px] scrollbar-thin"
      >
        {children}
      </div>
    </div>
  );
}
